// @flow

export const BREAKPOINT_MOBILE = 'mobile'
export const BREAKPOINT_DESKTOP = 'desktop'
